import axios from "../../lib/axiosInstance";

export function fetchPrivateChatMessages(id) {
  return axios.get(`chats/${id}`).then((res) => res.data);
}
export function fetchChatUsers(id) {
  return axios.get(`chats/users/${id}`).then((res) => res.data);
}

// One page of room history. `cursor` is the oldest message id already loaded;
// omit it for the newest page. Returns { messages (oldest first), nextCursor, hasMore }.
export function fetchGroupChatMessagesByChatroom(id, { cursor, limit } = {}) {
  return axios
    .get(`chats/${id}`, {
      params: {
        ...(cursor ? { cursor } : {}),
        ...(limit ? { limit } : {}),
      },
    })
    .then((res) => res.data);
}

export function fetchGroupChatUsersForWorkOrder(payload) {
  return axios
    .get(`chats/users/${payload?.workOrderId}/${payload?.companyId}`)
    .then((res) => res.data);
}

// Fetch existing or create a new chat room
export function fetchOrCreateChatRoom(payload) {
  return axios.post(`chats/room`, payload);
}

export function fetchOrCreateGroupChatRoom(payload) {
  return axios.post(`chats/room/group`, payload);
}

export function uploadMessageFiles(formData) {
  return axios.post(`chats/files`, formData);
}

export function addChatParticipants(chatRoomId, { userIds, sharePreviousMessages }) {
  return axios
    .post(`chats/${chatRoomId}/participants`, { userIds, sharePreviousMessages })
    .then((res) => res.data);
}

export function removeChatParticipants(chatRoomId, { userIds }) {
  return axios
    .delete(`chats/${chatRoomId}/participants`, { data: { userIds } })
    .then((res) => res.data);
}
